import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../../api/queryClient';
import {
  getV1RequestBusinessPartnerByIdOptions,
  getV1RequestBusinessPartnerByIdQueryKey,
} from '../../api/generated/pm/@tanstack/react-query.gen';

/**
 * Query hooks for Business Partner Requests: the request read by id from the
 * emailed review link (also read by the edit modal and the review actions).
 * See `../Settings/IdentityProviders/identityProviders.queries.ts` for the
 * pattern.
 */

export function useRequestBusinessPartner(id: string | null) {
  return useQuery({
    ...getV1RequestBusinessPartnerByIdOptions({ path: { id: id as string } }),
    enabled: !!id,
  });
}

/**
 * Clears every cached Business Partner Request regardless of id (the generated
 * key requires a path, so the prefix is derived by dropping it).
 */
export const invalidateRequestBusinessPartner = () => {
  const [{ _id, baseUrl }] = getV1RequestBusinessPartnerByIdQueryKey({ path: { id: '' } });
  return queryClient.invalidateQueries({ queryKey: [{ _id, baseUrl }] });
};
